import { errorOfType, errorTypes } from '../../utilities/Errors'
import getCurrentUid from '../../utilities/getCurrentUid'

const getUserProfile = firestore => async ({ uid, userName, fromPublic = false, withFlags = true }) => {
	try {
		// must supply one of uid or userName
		if (!uid && !userName) {
			return Promise.reject(errorOfType(errorTypes.KEYNOTSPECIFIED, 'getUserProfile'))
		}

		// from the public or regular collection
		const collection = fromPublic ? 'userProfilesPublic' : 'userProfiles'
		const userProfilesCollRef = firestore.collection(collection)
		let userProfileDocSnap
		// use uid if provided, otherwise by name
		if (uid) {
			userProfileDocSnap = await userProfilesCollRef.doc(uid).get()
		} else {
			const userProfileQuerySnap = await userProfilesCollRef.where('userName', '==', userName).get()
			userProfileDocSnap = userProfileQuerySnap.docs.find(userProfileQueryDocSnap => userProfileQueryDocSnap.exists)
		}
		// check that user was found
		if (!userProfileDocSnap || !userProfileDocSnap.exists) {
			return Promise.reject(errorOfType(errorTypes.NOTFOUND, { uid, userName }))
		}
		const userProfileDocRef = userProfileDocSnap.ref

		// get the profile
		const userProfile = userProfileDocSnap.data()

		// respect deleted flag
		if (userProfile.deleted) {
			return Promise.reject(errorOfType(errorTypes.NOTFOUND, { uid, userName, reason: 'deleted' }))
		}

		// maybe get the status flags (is following, has verifed) for the current user
		if (withFlags && !fromPublic) {
			const currentUid = getCurrentUid()
			if (currentUid) {
				// check the loaded profile's subcollections for references to the current user
				const [
					followersDocSnap,
					verifiersDocSnap
				] = await Promise.all([
					userProfileDocRef.collection('followers').doc(currentUid).get(),
					userProfileDocRef.collection('verifiers').doc(currentUid).get()
				])
				userProfile.isFollowing = followersDocSnap.exists
				userProfile.hasVerified = verifiersDocSnap.exists
				if (verifiersDocSnap.exists) {
					userProfile.relationshipType = verifiersDocSnap.data().relationshipType
				}
			}
		}

		return { userProfile }
	} catch (error) {
		return Promise.reject(errorOfType(errorTypes.UNKNOWNERROR, { uid, userName, error }))
	}
}

export default getUserProfile



// WEBPACK FOOTER //
// ./src/dataservices/getUserProfile/internal.js